import theme from '@styles/theme';
export default {
  linkButton: (active?: boolean) => ({
    fontFamily: `'${theme.fonts.uniformMedium}'`,
    textTransform: 'uppercase',
    cursor: 'pointer',
    fontWeight: theme.fontWeights.medium,
    fontSize: `${theme.fontSizes.text}px`,
    width: 'auto',
    mr: '40px',
    pb: '3px',
    border: 'none',
    background: 'transparent',
    borderBottom: '1px solid transparent',
    transition: 'all .3s linear',
    whiteSpace: 'nowrap',
    color: theme.rawColors.darkGrey700,
    borderColor: active ? theme.rawColors.darkGrey700 : 'transparent',
    '&:hover': {
      borderColor: theme.rawColors.darkGrey700
    },
    '&:focus': {
      borderBottom: '1px solid transparent',
      borderColor: active ? theme.rawColors.darkGrey700 : 'transparent'
    },
    '&:last-of-type': {
      mr: 0
    }
  })
};